import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl } from "../../../";
import CheckIcon from '@mui/icons-material/Check';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { LocalizedStringsMethods } from "react-localization";

function TextControl(props: DynamicFormControl) {
    const [value, setValue] = useState(props.value ?? '');
    const [isValid, setIsValid] = useState(true);
    const [customLabelClass, setCustomLabelClass] = useState<string>('MuiFormLabel-root');

    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    const handleChange = (event: any) => {
        let newValue = event.target.value as string;

        if (props.regexValidation != null) {
            const regex = new RegExp(props.regexValidation);
            if (newValue) {
                const valid = regex.test(newValue);

                if (!valid && props.restrictRegexCharacters) {
                    newValue = value;
                } else {
                    setIsValid(valid);
                }
            } else {
                setIsValid(true);
            }
        }

        if (props.setState) {
            props.setState(newValue);
        }
        setValue(newValue);
        setEnabled(newValue != null && newValue !== '');

        if (newValue) {
            setCustomLabelClass('MuiFormLabel-root MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled');
        }
    };

    const [enabled, setEnabled] = useState(props.disabled ? false : true);
    const handleClickEnableDisable = () => {
        if (props.setDisabled) {
            props.setDisabled(enabled);
        }
        setEnabled(!enabled);
    };
    const handleMouseDownEnableDisable = (event: any) => {
        event.preventDefault();
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value ?? '');
        };
    }

    return (
        <div>
            {props.customLabel ?
                <label className={customLabelClass}>{label}{props.required ? '*' : ''}</label> : null}

            <TextField
                error={!isValid}
                value={value}
                onChange={handleChange}
                autoComplete={props.autoComplete}
                autoFocus={props.autoFocus}
                fullWidth={props.fullWidth}
                id={props.id}
                name={props.name}
                placeholder={props.placeholder}
                required={props.required}
                rows={props.rows}
                maxRows={props.rowsMax}
                size={props.size}
                style={{ marginTop: props.customLabel ? '0' : '' }}
                label={props.customLabel ? '' : label}
                multiline={props.multiline}
                key={props.id ?? label}
                type={props.inputType}
                disabled={props.disabled}
                inputProps={{ pattern: props.regexValidation, maxLength: props.maxLength }}
                InputProps={
                    props.toggleDisabled ?
                        {
                            startAdornment: <InputAdornment position="start">
                                <Tooltip title={enabled ? 'Reported' : 'Not Reported'}>
                                    <IconButton
                                        tabIndex={-1}
                                        aria-label="toggle field"
                                        onClick={handleClickEnableDisable}
                                        onMouseDown={handleMouseDownEnableDisable}
                                    >
                                        {enabled ? <CheckIcon /> : <NotInterestedIcon />}
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>,
                        } : undefined}
            />
        </div>
    )
}


export default TextControl;
